import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/es",
    name: "/es",
    redirect: "/es/index",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home_ES.vue"),
    children: [
      {
        path: "/es/index",
        name: "Overview",
        component: () => import("../views/es/overview/index.vue"),
      },
      {
        path: "/es/recruitment",
        name: "Recruitment",
        component: () => import("../views/es/recruitment/index.vue"),
      },
    ],
  },
  {
    path: "/home",
    name: "Home",
    redirect: "/index",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
    children: [
      {
        path: "/index",
        name: "首页",
        component: () => import("../views/school/SchoolSurvey.vue"),
      },
      {
        path: "/details/:type?/:id?",
        name: "详情",
        component: () => import("../views/details/NewsDetails.vue"),
      },
      {
        path: "/partyDetails/:type?/:id?",
        name: "详情",
        component: () => import("../views/details/PartyDetails.vue"),
      },
      {
        path: "/detail/:type?/:id?/:view?",
        name: "详情",
        component: () => import("../views/details/OtherDetails.vue"),
      },
      {
        path: "/more",
        name: "更多",
        component: () => import("../views/details/NewsMore.vue"),
      },
      // {
      //   path: "/SchoolSurvey",
      //   name: "学院概况",
      //   component: () => import("../views/school/SchoolSurvey.vue"),
      // },
      {
        path: "/SchoolLntro/:items?",
        name: "学院概况",
        component: () => import("../views/school/SchoolLntro.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/partyBuild/:items?",
        name: "党的建设",
        component: () => import("../views/partyBuild/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/treeman/:items?",
        name: "立德树人",
        component: () => import("../views/treeman/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/talentTrain/:items?",
        name: "人才培养",
        component: () => import("../views/talentTrain/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/teachers/:items?",
        name: "师资队伍",
        component: () => import("../views/teachers/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/discipline/:items?",
        name: "学科与科研",
        component: () => import("../views/discipline/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/exchange/:items?",
        name: "对外交流",
        component: () => import("../views/exchange/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/recruit/:items?",
        name: "招生宣传",
        component: () => import("../views/recruit/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/oldBoy/:items?",
        name: "校友之窗",
        component: () => import("../views/oldBoy/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/experimentalCondition/:items?",
        name: "实验条件",
        component: () => import("../views/experimentalCondition/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/talents/:items?",
        name: "人才招聘",
        component: () => import("../views/talents/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/journalism/:items?",
        name: "新闻详情",
        component: () => import("../views/journalism/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/personParticulars/:items?",
        name: "人物详情",
        component: () => import("../views/personParticulars/index.vue"),
        meta: { keepAlive: true },
      },
      {
        path: "/safetyCampus/:items?",
        name: "平安校园",
        component: () => import("../views/safetyCampus/index.vue"),
        meta: { keepAlive: true },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

// 全局处理重复导航错误（关键：解决 NavigationDuplicated）
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    // 仅忽略重复导航错误，其他错误正常抛出
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

// 重写 replace 方法（防止 replace 跳转也报错）
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
